import React, { useEffect } from 'react';
import { useModalAction, MODAL_VIEWS } from "../../components/modal/modal.context";

const AuthPage = ({ view = 'LOGIN' }: { view?: MODAL_VIEWS }) => {
  const { openModal, closeModal } = useModalAction();

  useEffect(() => {
    closeModal();
    if (view) {
      openModal(view);
    }
  }, [view]);

  return null;
};

export default AuthPage;
